// src/nav/navConfig.js

import { FiActivity, FiGrid, FiGitBranch,  } from "react-icons/fi";


export const NAV = [
  // {
  //   key: "sales",
  //   label: "Sales",
  //   base: "/sales",
  //   aliases: [],
  //   tabs: [
  //     { key: "overview", label: "Overview", to: "/sales/overview" },
  //     { key: "accounts", label: "Accounts", to: "/sales/accounts" },
  //     { key: "orders", label: "Orders", to: "/sales/orders" },
  //   ],
  //   defaultTo: "/sales/overview",
  // },
  {
    key: "data-flow",
    label: "Data Flow",
    base: "/data-flow",
    aliases: ["/ingest"], // ✅ compat
    tabs: [
      { key: "live", label: "Live", to: "/data-flow/live", icon: FiActivity },
      { key: "dashboard", label: "Dashboard", to: "/data-flow/dashboard", icon: FiGrid  },
      { key: "pipeline", label: "Pipeline", to: "/data-flow/pipeline", icon: FiGitBranch  },
    ],
    defaultTo: "/data-flow/dashboard",
  },
  // {
  //   key: "support",
  //   label: "Support",
  //   base: "/support",
  //   aliases: [],
  //   tabs: [
  //     { key: "tickets", label: "Tickets", to: "/support/tickets" },
  //     { key: "alerts", label: "Alerts", to: "/support/alerts" },
  //     { key: "incidents", label: "Incidents", to: "/support/incidents" },
  //   ],
  //   defaultTo: "/support/tickets",
  // },
  {
    key: "performance",
    label: "Performance",
    base: "/performance",
    aliases: ["/perf"], // ✅ compat
    tabs: [
      { key: "kpis", label: "Dashboard", to: "/performance/PerfDashboard", icon: FiGrid },
      // { key: "trends", label: "Trends", to: "/performance/trends" },
      // { key: "reports", label: "Reports", to: "/performance/reports" },
    ],
    defaultTo: "/performance/PerfDashboard",
  },
  
];
